import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight, Instagram } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-sea-blue text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_settle-denmark/artifacts/scbjg6pa_create-a-minimalist-3d-style-logo-for-a-_TN12f73sSb-P_h61fzuk9g_oHByH8kJQ22T-0R9tkj5ow.jpeg"
              alt="Next Step Denmark Logo"
              className="h-20 w-auto object-contain mb-4 rounded-lg"
            />
            <p className="text-white/80 text-sm">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-white/80 hover:text-bronze transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/services/private" className="text-white/80 hover:text-bronze transition-colors">
                  {t('nav.forPrivate')}
                </Link>
              </li>
              <li>
                <Link to="/services/companies" className="text-white/80 hover:text-bronze transition-colors">
                  {t('nav.forCompanies')}
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-white/80 hover:text-bronze transition-colors">
                  {t('nav.book')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-bronze transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-bronze transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Direction */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.contactTitle')}</h3>
            <p className="text-white/80 text-sm mb-4">
              {t('footer.contactText')}
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 text-bronze hover:text-bronze/80 transition-colors text-sm font-medium mb-6"
            >
              {t('footer.contactLink')}
              <ArrowRight className="h-4 w-4" />
            </Link>
            
            {/* Instagram Link */}
            <div className="mt-6">
              <h3 className="font-semibold mb-3">{t('footer.followUs')}</h3>
              <a 
                href="https://www.instagram.com/nextstepdenmark/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-white/80 hover:text-bronze transition-colors text-sm"
              >
                <Instagram className="h-5 w-5" />
                <span>Instagram</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/20 text-center text-sm text-white/60">
          <p>© {currentYear} Next Step Denmark. {t('footer.rights')}.</p>
        </div>
      </div>
    </footer>
  );
};
